import { Injectable } from '@angular/core';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { TriggerJobRequestModel } from '../business-entities/syncJob-view-model';

@Injectable({
  providedIn: 'root'
})
export class SyncJobDataService {

  constructor(private dataProvider: DataService) { }

  getSyncJobList(): Promise<any> {
    return this.dataProvider.GetAll<GenericResponse<any>>(Urls.GetSyncJobList).toPromise();
  }

  triggerJob(model:TriggerJobRequestModel):Promise<any>{
    let url=Urls.TriggerJob+model.controllerName+'/'+model.actionName;
    return this.dataProvider.Get<GenericResponse<any>>(url,model.syncJobId).toPromise();
  }
}
